import { Pipe, PipeTransform } from '@angular/core';
import { Timestamp } from '@angular/fire/firestore';
import moment from 'moment';

@Pipe({
  name: 'dateRange',
  standalone: true // Optional: If using standalone components in Angular 19
})
export class DateRangePipe implements PipeTransform {
  transform(startDate: Timestamp , endDate: Timestamp): string {
    const start = moment(startDate.toDate() );
    const end = moment(endDate.toDate() );

    if (!start.isValid() || !end.isValid()) {
      return 'Invalid dates';
    }

    let startFormat = 'MMM D';
    let endFormat = 'MMM D, YYYY';

    if (start.year() !== end.year()) {
      startFormat += ', YYYY';
      endFormat = 'MMM D, YYYY';
    } else if (start.month() === end.month()) {
      endFormat = 'D, YYYY';
    }

    const formattedStart = start.format(startFormat);
    const formattedEnd = end.format(endFormat);

    return `${formattedStart} - ${formattedEnd}`;
  }
}